/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: network-view-service
 *
 * Created by rwilliams on 7/19/17.
 */
'use strict';
angular.module('prism-ui.network').service('NetworkViewService',
    function (_,
              $q,
              $routeParams,
              $location,
              BreadcrumbService,
              PermissionsService,
              NotificationService,
              NetworkResourceFactory,
              MetaPropsResourceFactory) {
        var self = this;

        var _networkComponentsMap = {};

        var setBreakPrePostrollPermissions = function (permissions) {
            var readPerms = permissions.preroll.read && permissions.postroll.read;
            var writePerms = permissions.preroll.write && permissions.postroll.write;

            permissions.breakprepostroll = {read: readPerms, write: writePerms};
            return permissions;
        };

        var getTabViewPermissions = function () {
            var prerollPromise = PermissionsService.getReadWritePermissions(
                self.permissionViewStates.NETWORK_PREROLL_SEARCH_VIEW_STATE);
            var postrollPromise = PermissionsService.getReadWritePermissions(
                self.permissionViewStates.NETWORK_POSTROLL_SEARCH_VIEW_STATE);
            var watermarkPromise = PermissionsService.getReadWritePermissions(
                self.permissionViewStates.NETWORK_WATERMARK_SEARCH_VIEW_STATE);
            var artworkPromise = PermissionsService.getReadWritePermissions(
                self.permissionViewStates.NETWORK_ARTWORK_SEARCH_VIEW_STATE);
            var ratingOverlayPromise = PermissionsService.getReadWritePermissions(
                self.permissionViewStates.NETWORK_RATING_OVERLAY_SEARCH_VIEW_STATE);

            return $q.all({
                preroll: prerollPromise,
                postroll: postrollPromise,
                watermark: watermarkPromise,
                artwork: artworkPromise,
                ratingOverlay: ratingOverlayPromise,
            }).then(function (permissions) {
                return setBreakPrePostrollPermissions(permissions);
            });
        };

        var resetBreadcrumbs = function () {
            BreadcrumbService.clearBreadcrumbs();
            BreadcrumbService.addBreadcrumb({
                name: 'Networks',
                location: '/meta/networks/search',
                params: angular.copy($location.search())
            });
        };

        var closeEditView = function () {
            resetBreadcrumbs();
            self.network = null;
            self.editorForm = null;

            $location.path(self.parentRoute);
        };

        var canExitEditView = function () {
            return !self.editorForm || (self.network.id && self.editorForm.$pristine);
        };

        var revertComponents = function () {
            angular.forEach(self.networkComponentsMap(), function (comp, key) {
                comp.instanceData.value = self.originalNetworkData.metadata.properties[key].value;
            });
        };

        self.permissionViewStates = {
            NETWORK_VIEW_STATE: 'NETWORK_VIEW_STATE',
            NETWORK_PREROLL_SEARCH_VIEW_STATE: 'NETWORK_PREROLL_SEARCH_VIEW_STATE',
            NETWORK_POSTROLL_SEARCH_VIEW_STATE: 'NETWORK_POSTROLL_SEARCH_VIEW_STATE',
            NETWORK_BREAKPREPOSTROLL_SEARCH_VIEW_STATE: 'NETWORK_BREAKPREPOSTROLL_SEARCH_VIEW_STATE',
            NETWORK_WATERMARK_SEARCH_VIEW_STATE: 'NETWORK_WATERMARK_SEARCH_VIEW_STATE',
            NETWORK_ARTWORK_SEARCH_VIEW_STATE: 'NETWORK_ARTWORK_SEARCH_VIEW_STATE',
            // TODO: Consolidate all branding asset permissions into 1
            NETWORK_RATING_OVERLAY_SEARCH_VIEW_STATE: 'NETWORK_ARTWORK_SEARCH_VIEW_STATE',
        };
        self.editorForm = null;
        self.tabRevertFunction = null;
        self.parentRoute = '/meta/networks/search';
        self.originalNetworkData = null;

        self.getViewPermissions = function (viewStateKey) {
            if (viewStateKey) {
                return PermissionsService.getReadWritePermissions(viewStateKey);
            } else {
                return getTabViewPermissions();
            }
        };

        self.getSearchViewData = function (criteria, handleGridDataQuery) {
            self.breadcrumbName = '';
            return NetworkResourceFactory.getNetworks(criteria, handleGridDataQuery).$promise;
        };

        self.getEditViewData = function (criteria) {
            return NetworkResourceFactory.get(criteria).$promise.then(function (data) {
                self.breadcrumbName = data.name;
                self.originalNetworkData = _.cloneDeep(data);
                return data;
            });
        };

        self.saveNetwork = function (network) {
            if ($routeParams.id > -1) {
                return NetworkResourceFactory.update(network).$promise;
            }
            return NetworkResourceFactory.save(network).$promise;
        };

        self.revertEditData = function () {
            if (self.network) {
                self.network = _.cloneDeep(self.originalNetworkData);
                revertComponents();

                return self.network;
            } else {
                closeEditView();
            }
        };

        self.exitEdit = function () {
            if (canExitEditView()) {
                closeEditView();
            } else {
                NotificationService.createWarningNotification('You have unsaved changes.  Please save or revert.', '');
            }
        };

        self.networkComponentsMap = function (newNetworkComponentsMap) {
            if (arguments.length) {
                _networkComponentsMap = newNetworkComponentsMap;
            }
            return _networkComponentsMap;
        };
    });
